export default {
  'calendar.popover.more': 'more',
  'calendar.more.expanded.label': 'Show less',
  'calendar.more.collapsed.label': 'Show more',
};
